import React from "react";
import {Dialog} from "@mui/material";
import {useSelector} from "react-redux";
import CustomDialogTitle from "../custom-dialog-title";

const $ = window.jQuery;

const AlertDialog = ({
  open = false,
  title = null,
  onClose = null,
  maxWidth = "sm",
  className = "",
  onEnter,
  onExit,
  children,
  ...props
}) => {
  const messages = useSelector(state => state?.spinner?.messages ?? []);

  return (
    <Dialog
      {...props}
      open={open}
      maxWidth={maxWidth}
      onClose={onClose}
      className={`components__dialog components__dialog--alert ${className}`}
      disableEscapeKeyDown={messages.length > 0}
      slotProps={{
        transition: {
          onEnter: () => {
            document.body.classList.add("body--hidden-scrollbar");

            if (onEnter) onEnter();
          },
          onExit: () => {
            if ($(".components__dialog").length <= 1) {
              document.body.classList.remove("body--hidden-scrollbar");
            }

            if (onExit) onExit();
          }
        }
      }}
    >
      {title && (
        <CustomDialogTitle onClose={onClose} className="components__dialog__header--alert">
          {title}
        </CustomDialogTitle>
      )}
      {children}
    </Dialog>
  );
};

export default AlertDialog;
